import {
  BodyText,
  Button,
  CardAccordion,
  CardAccordionButton,
  CardAccordionFooter,
  CardAccordionItem,
  Flex,
  HelperText,
  TextInput,
} from '@utilitywarehouse/hearth-react';
import { useRef, useState } from 'react';

import { AppointmentParticipantType } from '@generated/gql/graphql';

import { accordions } from '../constants';

const getSectionIndex = (
  userType: AppointmentParticipantType,
  value: string
) => {
  return accordions[userType].findIndex((item) => item.value === value);
};

const getSectionTitle = (
  userType: AppointmentParticipantType,
  value: string
) => {
  const accordion = accordions[userType];
  const sectionIndex = getSectionIndex(userType, value);
  const section = accordion.find((item) => item.value === value);
  if (!section) return '';

  return `${sectionIndex + 1}. ${section.title}`;
};

interface PreJoinStepsProps {
  userType: AppointmentParticipantType;
  onStart: () => void;
}

const PreJoinSteps = ({ userType, onStart }: PreJoinStepsProps) => {
  const [name, setName] = useState<string>('');
  const isNameTouched = useRef<boolean>(false);
  const isNameValid = name.length > 2;

  return (
    <CardAccordion>
      {userType === AppointmentParticipantType.Customer && (
        <CardAccordionItem
          value="name"
          title={getSectionTitle(userType, 'name')}
          summaryDescription={
            <Flex direction="column">
              <HelperText>This is how you will be presented</HelperText>
              <BodyText weight="bold">{name}</BodyText>
            </Flex>
          }
        >
          <TextInput
            label="This is how you will be presented"
            placeholder="Enter your name"
            value={name}
            validationStatus={
              isNameValid
                ? 'valid'
                : isNameTouched.current
                  ? 'invalid'
                  : undefined
            }
            validationText={
              !isNameValid && isNameTouched.current
                ? 'Enter a valid name'
                : undefined
            }
            onChange={(e) => {
              isNameTouched.current = true;
              setName(e.target.value);
            }}
            required
          />

          <CardAccordionFooter>
            <CardAccordionButton action="next" disabled={!isNameValid}>
              Save and continue
            </CardAccordionButton>
          </CardAccordionFooter>
        </CardAccordionItem>
      )}

      <CardAccordionItem value="join" title={getSectionTitle(userType, 'join')}>
        <CardAccordionFooter>
          {accordions[userType].length > 1 && (
            <CardAccordionButton action="previous" />
          )}
          <Button
            variant="solid"
            size="md"
            colorScheme="highlight"
            onClick={onStart}
          >
            {userType === AppointmentParticipantType.Partner
              ? 'Create and join lobby'
              : 'Join lobby'}
          </Button>
        </CardAccordionFooter>
      </CardAccordionItem>
    </CardAccordion>
  );
};

export { PreJoinSteps };
